function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#CCCCCC;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Topo"), React.createElement("path", {
  className: "st0",
  d: "M30.9,23.5H4.5v20.1h29.4V26.5C33.9,24.9,32.6,23.5,30.9,23.5z"
}), React.createElement("rect", {
  x: 4.5,
  y: 44.4,
  className: "st0",
  width: 29.4,
  height: 6.8
}), React.createElement("rect", {
  x: 4.5,
  y: 52.2,
  className: "st0",
  width: 29.4,
  height: 6.8
}), React.createElement("rect", {
  x: 4.5,
  y: 60.1,
  className: "st0",
  width: 29.4,
  height: 6.8
}), React.createElement("rect", {
  x: 4.5,
  y: 67.9,
  className: "st0",
  width: 29.4,
  height: 6.8
}), React.createElement("path", {
  className: "st0",
  d: "M4.5,21.3v1.4h26.3c3.1,0,4.1,1.7,4.1,4.1v3.1h56.5v-8.6H4.5z M70.1,27.7C70.1,27.7,70.1,27.7,70.1,27.7 c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C72.3,26.8,71.3,27.7,70.1,27.7z M76,27.7C76,27.7,76,27.7,76,27.7 c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C78.2,26.8,77.2,27.7,76,27.7z M81.9,27.7c-1.2,0-2.2-1-2.2-2.2 c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C84.1,26.8,83.1,27.7,81.9,27.7z M87.8,27.7c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2 c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0C90,26.7,89,27.7,87.8,27.7z"
}));

var SvgLayout = function SvgLayout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLayout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LAYOUT.b56ad64f.svg";
export { ForwardRef as ReactComponent };